import { useState } from 'react';
import { Modal, ModalCloseButton, ModalContent, ModalOverlay, useDisclosure } from '@chakra-ui/react';
import { CbAreYouSureModal } from '../CbAreYouSureModal';
import { CbCreatePost, CbGiphy, CbFileUpload } from '.';
interface CbRichAnnouncementModalProps {
  isPosting: boolean;
  onClose: () => void;
  onPost: (announcementParams, files) => void;
}
enum ModalView {
  ImageUpload = 'image_upload',
  GIPHY = 'giphy',
  CreatePost = 'create_post',
  FileUpload = 'file_upload',
}
interface FileData {
  file: File;
  signed_blob_id: string;
}
export const CbRichAnnouncementModal = ({
  isPosting,
  onClose,
  onPost
}: CbRichAnnouncementModalProps) => {
  const [textContent, setTextContent] = useState('');
  const [imageURL, setImageURL] = useState<string | null>();
  const [previewUrl, setPreviewUrl] = useState(null);
  const [fileData, setFileData] = useState<FileData[]>([]);
  const [view, setView] = useState<ModalView>(ModalView.CreatePost);
  const {
    isOpen: confirmAbandonModalOpen,
    onClose: dismissConfirmAbandonModal,
    onOpen: showConfirmAbandonModal
  } = useDisclosure();
  const onGIF = () => setView(ModalView.GIPHY);
  const onFiles = () => setView(ModalView.FileUpload);
  const onReturnToCreatePost = () => setView(ModalView.CreatePost);
  const onSelectImage = (url: string) => {
    setImageURL(url);
    onReturnToCreatePost();
  };
  const handleClose = () => textContent ? showConfirmAbandonModal() : onClose();
  const removeFile = file => {
    setFileData(previousFileData => previousFileData.filter(data => data.file !== file));
  };

  // To Deprecate
  const onRemoveImage = () => {
    setImageURL(null);
    setPreviewUrl(null);
  };
  return <>
      <Modal isCentered isOpen onClose={handleClose} size="3xl" data-sentry-element="Modal" data-sentry-source-file="CbRichAnnouncementModal.tsx">
        <ModalOverlay data-sentry-element="ModalOverlay" data-sentry-source-file="CbRichAnnouncementModal.tsx" />
        <ModalContent minHeight={350} data-sentry-element="ModalContent" data-sentry-source-file="CbRichAnnouncementModal.tsx">
          <ModalCloseButton variant="cb-ghost" data-sentry-element="ModalCloseButton" data-sentry-source-file="CbRichAnnouncementModal.tsx" />
          <>
            <Modal isCentered isOpen onClose={handleClose} size="3xl" data-sentry-element="Modal" data-sentry-source-file="CbRichAnnouncementModal.tsx">
              <ModalOverlay data-sentry-element="ModalOverlay" data-sentry-source-file="CbRichAnnouncementModal.tsx" />
              <ModalContent minHeight={350} data-sentry-element="ModalContent" data-sentry-source-file="CbRichAnnouncementModal.tsx">
                <ModalCloseButton variant="cb-ghost" data-sentry-element="ModalCloseButton" data-sentry-source-file="CbRichAnnouncementModal.tsx" />
                {view === ModalView.GIPHY && <CbGiphy onReturnToCreatePost={onReturnToCreatePost} onSelectImage={onSelectImage} />}
                {view === ModalView.FileUpload && <CbFileUpload onReturnToCreatePost={onReturnToCreatePost} fileData={fileData} setFileData={setFileData} removeFile={removeFile} />}
                {view === ModalView.CreatePost && <CbCreatePost isPosting={isPosting} onGIF={onGIF} onFiles={onFiles} onPost={onPost} onRemoveImage={onRemoveImage} imageURL={imageURL} setTextContent={setTextContent} textContent={textContent} setPreviewUrl={setPreviewUrl} previewUrl={previewUrl} fileData={fileData} removeFile={removeFile} />}
              </ModalContent>
            </Modal>
          </>
        </ModalContent>
      </Modal>
      <CbAreYouSureModal confirmText="Discard" denyText="No" headerText="Discard Post?" isOpen={confirmAbandonModalOpen} onClose={dismissConfirmAbandonModal} onConfirm={onClose} subText="This draft post will be lost." data-sentry-element="CbAreYouSureModal" data-sentry-source-file="CbRichAnnouncementModal.tsx" />
    </>;
};